<script setup lang="ts">
  defineOptions({
    name: 'AuthPageLayout',
  })

  import type { PropType } from 'vue'

  import { Screens, type ScreenChangeData } from '@common/auth-layer/types'

  import AuthPageLayoutWeb from './AuthPageLayout.web.vue'

  defineProps({
    initialPage: {
      type: String as PropType<string>,
      default: Screens.LOGIN,
    },
    referrerUser: {
      type: Object as PropType<{
        email: string
        name: string
        _id?: string
      }>,
      default: undefined,
    },
    maskEmail: {
      type: Boolean,
      default: false,
    },
    deferSetPasswordSession: {
      type: Boolean,
      default: undefined,
    },
  })

  const emit = defineEmits<{
    (e: 'loginCallback', data: any): void
    (e: 'changeScreen', data: ScreenChangeData): void
  }>()

  const handleLoginCallback = (event: any) => {
    emit('loginCallback', event)
  }

  const handleChangeScreen = (data: ScreenChangeData) => {
    emit('changeScreen', data)
  }
</script>

<template>
  <AuthPageLayoutWeb
    :initial-page="initialPage"
    :referrer-user="referrerUser"
    :mask-email="maskEmail"
    :defer-set-password-session="deferSetPasswordSession"
    @login-callback="handleLoginCallback"
    @change-screen="handleChangeScreen"
  />
</template>
